import { render, staticRenderFns } from "./fiveBody.vue?vue&type=template&id=edbd7e92&scoped=true&"
import script from "./fiveBody.vue?vue&type=script&lang=js&"
export * from "./fiveBody.vue?vue&type=script&lang=js&"
import style0 from "./fiveBody.vue?vue&type=style&index=0&id=edbd7e92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbd7e92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edbd7e92')) {
      api.createRecord('edbd7e92', component.options)
    } else {
      api.reload('edbd7e92', component.options)
    }
    module.hot.accept("./fiveBody.vue?vue&type=template&id=edbd7e92&scoped=true&", function () {
      api.rerender('edbd7e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/fiveBody.vue"
export default component.exports